import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import {
  validadeEmail,
  isMobile,
  validadePhone,
} from '../../../utils/validation';
import { useForgotPassword } from './useForgotPassword';
import './ForgotPassword.css';
import { Label } from '../../../components/Label';
import { InputText } from '../../../components/InputText';
import { Button } from '../../../components/Button';
import { Text } from '../../../components/Text';
import { MaskedInput } from '../../../components/MaskedInput';
import NumericInput from '../../../components/NumericInput/NumericInput';

const ForgotPassword = ({ handleOption, history }) => {
  const {
    value,
    setValue,
    inputCode,
    setInputCode,
    loading,
    handleSubmit,
    handleValidateCode,
    phoneFlow,
  } = useForgotPassword({
    handleOption,
    history,
  });
  const [loginMask, setLoginMask] = useState('');

  const getLoginMask = (value) => {
    if (validadePhone(value.replace(/[^\d]/g, ''))) {
      if (value.replace(/[^\d]/g, '').length === 10) {
        return '(99) 9999-9999';
      }
      return '(99) 99999-9999';
    }
    return '';
  };

  useEffect(() => {
    setLoginMask(getLoginMask(value));
  }, [value]);

  const renderForm = () => (
    <div style={{ width: '100%' }}>
      <div style={{ textAlign: 'center' }}>
        <h4 style={{ margin: 0 }}>
          <b>Esqueci a Senha</b>
        </h4>
        <p style={{ fontSize: '0.875rem', margin: 0 }}>
          Informe o seu email ou celular para redefinir a senha
        </p>
        <br />
      </div>
      <div>
        <Label required>E-mail ou Celular</Label>
        <MaskedInput
          mask={loginMask}
          value={value}
          onChange={(event) => setValue(event.target.value)}
        />
      </div>
      {isMobile() ? (
        <div className="forgot-password-actions-mobile">
          <Button
            color="green450"
            onClick={handleSubmit}
            disabled={
              (!validadeEmail(value) &&
                !validadePhone(value.replace(/[^\d]/g, ''))) ||
              loading
            }
          >
            Enviar
            {loading && (
              <span
                className="fa fa-spinner fa-pulse fa-1x"
                style={{ marginLeft: '5px' }}
              />
            )}
          </Button>
        </div>
      ) : (
        <div className="forgot-password-actions-desktop">
          <Button
            color="green450"
            onClick={handleSubmit}
            disabled={
              (!validadeEmail(value) &&
                !validadePhone(value.replace(/[^\d]/g, ''))) ||
              loading
            }
          >
            Enviar
            {loading && (
              <span
                className="fa fa-spinner fa-pulse fa-1x"
                style={{ marginLeft: '5px' }}
              />
            )}
          </Button>
        </div>
      )}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <span
          style={{
            textAlign: 'center',
            fontSize: '0.8750rem',
            cursor: 'pointer',
          }}
          id="link"
          onClick={() => handleOption(0)}
        >
          Já possui conta? Ir para Login
        </span>
      </div>
    </div>
  );

  const renderPhoneFlow = () => (
    <div style={{ width: '100%' }}>
      <div style={{ textAlign: 'center' }}>
        <h4 style={{ margin: 0 }}>
          <b>Esqueci a Senha</b>
        </h4>
        <p style={{ fontSize: '0.875rem', margin: 0 }}>
          Verifique se você recebeu uma mensagem em seu Whatsapp contendo seu
          código. Seu código tem 6 números.
        </p>
        <br />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <NumericInput
          length={6}
          onChange={(newValue) => setInputCode(newValue)}
        />
      </div>
      <div>
        <Text
          size="sm"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            marginTop: '5px',
          }}
        >
          <a href="#" onClick={handleSubmit}>
            Reenviar código
          </a>
        </Text>
      </div>
      <br />
      {isMobile() ? (
        <div className="forgot-password-actions-mobile">
          <Button
            color="green450"
            onClick={handleValidateCode}
            disabled={!validadeEmail(value) || loading}
          >
            Enviar
            {loading && (
              <span
                className="fa fa-spinner fa-pulse fa-1x"
                style={{ marginLeft: '5px' }}
              />
            )}
          </Button>
        </div>
      ) : (
        <div className="forgot-password-actions-desktop">
          <Button
            color="green450"
            onClick={handleValidateCode}
            disabled={!inputCode || inputCode.length !== 6}
          >
            Confirmar
            {loading && (
              <span
                className="fa fa-spinner fa-pulse fa-1x"
                style={{ marginLeft: '5px' }}
              />
            )}
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <div style={{ width: '100%' }}>
      <div>
        <div>{phoneFlow ? renderPhoneFlow() : renderForm()}</div>
        <br />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Text
            color="red400"
            size="xs"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            Em caso de dúvidas ou problemas, contate o&thinsp;
            <a href="mailto:ouvidoria@sobrerodas.club">
              ouvidoria@sobrerodas.club
            </a>
          </Text>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
